import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { api_freedom } from '../services/apis';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import PrintButton from "../components/PrintButton";

const SimulacaoCobranca = () => {
	const payload = JSON.parse(localStorage.getItem('simulacao_payload'));
	const [detalheBoleto, setDetalheBoleto] = useState([]);
	const [mensagem, setMensagem] = useState('Carregando ....');
	const fetchContrato = async (contratoId, imobiliariaId) => {
		try {
			const response = await api_freedom.get(
				`/demonstrativo/contrato/detalhe/${contratoId}/${imobiliariaId}`,
				{ headers: { "authorization": localStorage.getItem('autenticado_freedom') } }
			);

			if (response.data.data.indexOf('TOKEN') === -1 && response.data.data[0]) {
				return response.data.data[0];
			}
			return {};
		} catch (error) {
			console.error("Error fetching contract:", error.message);
			return {};
		}
	};

	const fetchCobrancas = async (contratoId, financeiroId, imobiliariaId = 53) => {
		try {
			const response = await api_freedom.get(
				`/demonstrativo/financeiro/idcontrato/${contratoId}/${imobiliariaId}`,
				{ headers: { "authorization": localStorage.getItem('autenticado_freedom') } }
			);

			const data = response.data.data;

			if (data.indexOf('TOKEN') === -1) {
				const parcela = data.find(p =>
					p.id === parseInt(financeiroId) &&
					p.servico_id !== 50 &&
					p.cobranca !== 1
				);

				if (!parcela) {
					return { descricao_parcela: [], valor_boleto: 0, parcela: null };
				}

				const descricao_parcela = data.filter(p =>
					p.mes_ano === parcela.mes_ano &&
					p.gerar_boleto === 1 &&
					p.servico_id !== 50 &&
					p.cobranca !== 1
				);

				let valor_boleto = 0;
				for (const dp of descricao_parcela) {
					if (dp.credito_debito === 1) {
						valor_boleto += dp.valor;
					} else {
						valor_boleto -= dp.valor;
					}
				}

				return {
					descricao_parcela,
					valor_boleto,
					parcela
				};
			}

			return { descricao_parcela: [], valor_boleto: 0, parcela: null };
		} catch (error) {
			console.error("Erro ao buscar cobranças:", error.message);
			return { descricao_parcela: [], valor_boleto: 0, parcela: null };
		}
	};


	const fetchPessoa = async (cpfCnpj, imobiliariaId) => {
		try {
			if (!cpfCnpj || !imobiliariaId) return {};

			const response = await api_freedom.post(
				'/pessoa/cpfcnpj',
				{
					cpf_cnpj: cpfCnpj,
					imobiliaria_id: imobiliariaId
				},
				{ headers: { "authorization": localStorage.getItem('autenticado_freedom') } }
			);

			if (response.data.data.indexOf('TOKEN') === -1 && response.data.data.length > 0) {
				return response.data.data[0];
			}
			return {};
		} catch (error) {
			console.error("Error fetching person data:", error.message);
			return {};
		}
	};
	
useEffect(() => {
  const processBoletos = async () => {
    if (!payload || (!payload.boletos && !payload.imobiliaria_id)) {
      setMensagem('Nenhum registro encontrado.');
      return;
    }

    let boletoToProcess = [];

    if (Array.isArray(payload.boletos) && payload.boletos.length > 0) {
      boletoToProcess = payload.boletos;
    } else if (payload.imobiliaria_id) {
      boletoToProcess = [payload];
    }

    if (boletoToProcess.length === 0) {
      setMensagem('Nenhum registro encontrado.');
      return;
    }

    const allBoletosPromises = boletoToProcess.map(async (boleto) => {
      const { contrato_id, id, imobiliaria_id } = boleto;

      if (!contrato_id || !id || !imobiliaria_id) {
        return null;
      }

      try {
        const [contratoData, cobrancasData] = await Promise.all([
          fetchContrato(contrato_id, imobiliaria_id),
          fetchCobrancas(contrato_id, id, imobiliaria_id)
        ]);

        const pessoaData = await fetchPessoa(
          cobrancasData.ted?.cpf_cnpj,
          cobrancasData.ted?.imobiliaria_id
        );


        return {
          contrato: contratoData,
          descricao_parcela: cobrancasData.descricao_parcela,
          pessoa: pessoaData,
          valor_boleto: cobrancasData.valor_boleto,
          originalRepasse: boleto
        };
      } catch (error) {
        console.error('Erro ao processar boleto:', error);
        return null;
      }
    });

    const allBoletos = (await Promise.all(allBoletosPromises)).filter(
      (boleto) => boleto !== null
    );

    setDetalheBoleto(allBoletos);
    setMensagem(allBoletos.length > 0 ? '' : 'Nenhum registro encontrado.');
  };

  processBoletos();
}, []);


	const totalResumo = useMemo(() => {
		if (!detalheBoleto || detalheBoleto.length === 0) return { total: 0, valor: 0 };

		const total = detalheBoleto.length;
		const valor = detalheBoleto.reduce((acc, boleto) => acc + parseFloat(boleto.valor_boleto || 0), 0);

		return { total, valor };
	}, [detalheBoleto]);


	const renderDescricaoParcela = (record, index, currentContrato) => {
		if (record.nome.toLowerCase() === "tarifa de ted") {
			return null;
		}

		if (record.servico_id === 6) {
			return (
				<tr key={index} className="stripedColor">
					<td align="left" style={{ fontSize: '14px', padding: '5px' }}>
						{record.referencia || record.nome}
					</td>
					<td align="right" style={{ fontSize: '14px' }}>
						{parseInt(record.descontar_repasse) === 1 ? '-' : ''}
						{parseFloat(record.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
					</td>
				</tr>
			);
		}

		let valor_repasse_item = parseFloat(record.valor);

		return (
			<tr key={index} className="stripedColor">
				<td align="left" style={{ fontSize: '14px', padding: '5px' }}>
					{record.referencia || record.nome}
				</td>
				<td align="right" style={{ fontSize: '14px' }}>
					{parseInt(record.descontar_repasse) === 1 ? '-' : ''}
					{valor_repasse_item.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
				</td>
			</tr>
		);
	};

	return (
		<div className='demonstrativo' style={{
			width: '100vw',
			minHeight: '100vh',
			position: 'absolute',
			top: 0,
			left: 0,
			zIndex: 1000,
			backgroundColor: '#f9f9f9',
			overflowY: 'auto',
		}}>
			<div className="container" style={{ color: '#000000', margin: '0 auto', maxWidth: '90%', padding: '20px' }}>
				<div style={{
					width: '100%',
					height: '100%',
					margin: '0',
					boxSizing: 'border-box',
					fontFamily: 'sans-serif',
					fontSize: '18px'
				}}>
					{mensagem ? (
						<div style={{ padding: '20px', textAlign: 'center' }}>{mensagem}</div>
					) : (
						<>
							{detalheBoleto.map((boleto, index) => {
								const locatarioPrincipal = boleto.contrato?.pessoas?.find(
									p => p.tipo === 'Locatário' && p.principal === 1
								);

								return (
									<div key={index} style={{
										width: '100%',
										padding: '0px 15px',
										paddingTop: '30px',
										marginLeft: 'auto',
										marginRight: 'auto',
										pageBreakInside: 'avoid',
										breakInside: 'avoid',
										printColorAdjust: 'exact',
										backgroundColor: '#fff',
										borderBottom: '1px solid #eee',
										marginBottom: '20px'
									}}>
										<p style={{ fontSize: '12px' }}>
											<span style={{ fontWeight: 'bold' }}>Contrato</span> {boleto.contrato.id}
										</p>
										<h4 style={{ margin: '0' }}>
											Locatário: &nbsp;
											{locatarioPrincipal ? locatarioPrincipal.nome : ''}
										</h4>

										<div className='table-responsive'>
											<table className='table' style={{ width: '100%' }}>
												<tbody>
													<tr>
														<th align="left" style={{ fontSize: '14px', padding: '5px' }} colSpan="1">Contrato</th>
														<td style={{ fontSize: '14px' }} colSpan="5">
															{boleto.contrato.imovel?.[0] ?
																`${boleto.contrato.imovel[0].endereco}, ${boleto.contrato.imovel[0].numero} ${boleto.contrato.imovel[0].complemento},
							${boleto.contrato.imovel[0].bairro} - ${boleto.contrato.imovel[0].cidade} /
							${boleto.contrato.imovel[0].estado} - ${boleto.contrato.imovel[0].cep}` : ''}
														</td>
													</tr>
													<tr style={{ backgroundColor: '#eee' }}>
														<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Início</th>
														<td style={{ fontSize: '14px' }}>
															{boleto.contrato.data_inicio ? moment(boleto.contrato.data_inicio).utc(false).format('DD/MM/YYYY') : ''}
														</td>
														<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Término</th>
														<td style={{ fontSize: '14px' }}>
															{boleto.contrato.data_fim ? moment(boleto.contrato.data_fim).utc(false).format('DD/MM/YYYY') : ''}
														</td>
														<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Taxa de Administração/ Fixa:</th>
														<td style={{ fontSize: '14px' }}>
															{boleto.contrato.is_taxa_fixa === 1
																? (boleto.contrato.perc_taxa_administracao
																	? parseFloat(boleto.contrato.perc_taxa_administracao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
																	: '')
																: (boleto.contrato.perc_taxa_administracao
																	? `${parseFloat(boleto.contrato.perc_taxa_administracao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
																	: '')
															}
														</td>
														<th align="left" style={{ fontSize: '14px', padding: '5px' }}></th>
														<td style={{ fontSize: '14px' }}></td>
													</tr>
												</tbody>
											</table>
										</div>

										<div style={{ margin: '40px 0px' }}>
											<table style={{ width: '100%' }}>
												<tbody>
													<tr>
														<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', borderBottom: '1px solid #333' }} colSpan="2">Cobrança</td>
													</tr>
													<tr>
														<th align="left" style={{ fontSize: '14px', padding: '5px', width: '100px' }}>Referência</th>
														<td style={{ fontSize: '14px' }}>
															{boleto.descricao_parcela.length > 0 &&
																moment(boleto.descricao_parcela.find(p => p.id === parseInt(boleto.originalRepasse.id))?.data_vencimento)
																	.utc(false).format('DD/MM/YYYY')}
														</td>
													</tr>
												</tbody>
											</table>
										</div>

										<div className='table-responsive' style={{ margin: '40px 0px' }}>
											<table className='table' style={{ width: '100%' }}>
												<tbody>
													<tr>
														<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', borderBottom: '1px solid #333' }}>Detalhes do Boleto</td>
														<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', textAlign: 'right', borderBottom: '1px solid #333' }}>Valor</td>
													</tr>
													{boleto.descricao_parcela.map((record, descIndex) => renderDescricaoParcela(record, descIndex, boleto.contrato))}

													<tr style={{ fontWeight: 'bolder' }}>
														<td align="left" style={{ fontSize: '14px', padding: '5px' }}>Total da cobrança</td>
														<td align="right" style={{ fontSize: '14px' }}>
															{parseFloat(boleto.valor_boleto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								);
							})}

							{detalheBoleto.length > 0 && (
								<div
									style={{
										width: '100%',
										padding: '0px 15px',
										paddingTop: '30px',
										marginLeft: 'auto',
										marginRight: 'auto',
										backgroundColor: '#fff',
										borderTop: '1px solid #eee',
										marginBottom: '20px',
										pageBreakBefore: 'always'
									}}>
									<h3 style={{ margin: '0 0 20px 0', textAlign: 'center' }}>Resumo Geral</h3>

									<div className='table-responsive'>
										<table className='table' style={{ width: '100%' }}>
											<tbody>
												<tr>
													<td style={{ fontSize: '14px', padding: '5px' }}>Total de Cobranças</td>
													<td style={{ fontSize: '14px', padding: '5px' }}>
														{totalResumo.total}
													</td>
												</tr>
												<tr>
													<td style={{ fontSize: '14px', padding: '5px' }}>Valor Total</td>
													<td style={{ fontSize: '14px', padding: '5px' }}>
														{totalResumo.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							)}

						</>
					)}
				</div>
				<PrintButton />
			</div>
		</div>
	);
};

export default SimulacaoCobranca;